import { render, staticRenderFns } from "./Traspaso.vue?vue&type=template&id=4a386adc"
import script from "./Traspaso.vue?vue&type=script&lang=js"
export * from "./Traspaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports